<template>
    <div v-if="evento">
        <app-k-v
            titulo="Código do Evento"
            :md="4"
            :lg="3"
            :xl="3"
            :dado="evento.eventoId.toString()"
        ></app-k-v>
        <app-k-v titulo="Nome" :md="4" :lg="3" :xl="3" :dado="evento.nome"></app-k-v>
        <app-k-v
            titulo="Carga Horária"
            :md="4"
            :lg="3"
            :xl="3"
            :dado="evento.cargaHoraria.toString()"
        ></app-k-v>
        <app-k-v titulo="Responsável" :md="4" :lg="3" :xl="3" :dado="evento.nomeResponsavel"></app-k-v>
        <app-k-v
            titulo="Data Inicial"
            :md="4"
            :lg="3"
            :xl="3"
            :dado="$maskDateTime(evento.periodoInicial)"
        ></app-k-v>
        <app-k-v
            titulo="Data Final"
            :md="4"
            :lg="3"
            :xl="3"
            :dado="$maskDateTime(evento.periodoFinal)"
        ></app-k-v>
        <app-k-v titulo="Status" :md="4" :lg="3" :xl="3">
            <app-status :status="evento.situacao"></app-status>
        </app-k-v>
    </div>
</template>

<script>
export default {
	props: {
		evento: {
			type: Object,
			default: () => ({})
		}
	}
}
</script>
